import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Contract from "slotworks/utils/contract";
import { parallel } from "slotworks/utils/race-utils";

export function DimSymbolsCommand(symbols: SymbolComponent[]): Contract<void> {
    const dimSymbolMethods: Array<() => Contract<void>> = [];

    for (const symbol of symbols) {
        dimSymbolMethods.push(() => symbol.dim());
    }

    return parallel(dimSymbolMethods);
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/symbols/dim-symbols-command.ts